module.exports = __webpack_public_path__ + "img/horizontal_4_3_pp3_1.c8dbae05.png";